<template>
	<div>
		<div class="comment">
			<textarea placeholder="说说您的看法..." v-model="content"></textarea>
			<div class="comment-button">
				<button type="button" @click="giveMark">发送</button>
			</div>
		</div>
		<mask-dialog :open="isScoreDialogShow">
			<div class="score-dialog">
				<div class="score-dialog-main">
					<div class="score-dialog-title">对老师做个评价吧！</div>
					<div class="score-dialog-star">
						<star :num="5" @change="changeScore($event)" :canSlide="true"></star>
					</div>
					<div class="score-dialog-text">点击星星评分</div>
				</div>
				<div class="score-dialog-ops f-cb">
					<div class="score-dialog-later" @click="closeScoreDialog">下次再说</div>
					<div class="score-dialog-confirm" @click="sendComment">确定</div>
				</div>
			</div>
		</mask-dialog>
	</div>
</template>

<script>
	import mask from "../mask/mask.vue";
	import star from "../star/star.vue";
	export default{
		data(){
			return {
				content:"",
				isScoreDialogShow:false,
				score:10 //默认10分
			}
		},
		methods:{
			sendComment(){
				this.$api.get("",{
					api:"/v1/comment/create",
					course_id:this.$route.params.courseId,
					user_type:this.tools.getCookie("user_type"),
					content:this.content,
					practical_score:this.score,
					concise_score:this.score,
					clear_score:this.score
				},res=>{
					this.$toast('评论成功！');
					this.content="";
					this.isScoreDialogShow=false;
          //id为空代表从我的课程进入，跳回去。
					var id=this.$route.params.id;
					if(id){
            this.$router.push("/lesson-evaluate/"+this.$route.params.courseId+"/"+id);
          }
					else{
            this.$router.push("/me-lesson");
          }
				},res=>{
					this.$toast(res.msg);
				})
			},
			giveMark(){
				this.isScoreDialogShow=true;
			},
			changeScore(num){
				if(num<1) num=1;
				this.score=num*2;
			},
			closeScoreDialog(){
				this.isScoreDialogShow=false;
			}
		},
		components:{
			"mask-dialog":mask,
			star
		}
	}
</script>

<style>
	.comment textarea{
		padding:0.4rem;
		width:9.2rem;
		height:6.133rem;
		border:0;
		color:#999;
		background: #f2f2f2;
		font-size: 0.426rem;
	}
	.comment-button{
		position: absolute;
		bottom:0;
		left:0;
		width:10rem;
		height:1.173rem;
		line-height:1.173rem;
		background: #fff;
		text-align: center;
	}
	.comment-button button{
		width:9.2rem;
		height:0.96rem;
		color:#fff;
		background: #ec6d3a;
		border:0;
		border-radius: 0.133rem;
		font-size: 0.426rem;
		vertical-align: middle;
	}
	.score-dialog{
		overflow: hidden;
		text-align: center;
		border-radius: 0.106rem;
	}
	.score-dialog-main{
		width:8rem;
		height:2.613rem;
		padding-top:0.8rem;
		background: #fff;
	}
	.score-dialog-title{
		font-size: 0.426rem;
		line-height:0.426rem;
		color:#333;
	}
	.score-dialog-star{
		margin-top:0.533rem;
		height:0.56rem;
	}
	.score-dialog-text{
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.score-dialog-later,
	.score-dialog-confirm{
		float:left;
		box-sizing: border-box;
		width:4rem;
		height:1.173rem;
		line-height:1.173rem;
		text-align: center;
		font-size: 0.426rem;
	}
	.score-dialog-later{
		color:#ccc;
		border:1px solid #eee;
		background:#fff;
	}
	.score-dialog-confirm{
		color:#fff;
		background:#ec6d3a;
	}
</style>



// WEBPACK FOOTER //
// src/components/comment/comment.vue